<template>
  <v-form v-model="valid" style="background: #004a7d; height: 100vh">
    <v-container>
      <v-layout
        align-center
        justify-space-between
        row
        fill-height
        wrap
        style="border-bottom: 2px solid #00a4ff"
      >
        <v-flex style="margin: 0 auto 0 0">
          <v-img
            :src="require('@/assets/miniatura_white.png')"
            max-width="55px"
          />
        </v-flex>
        <v-flex wrap class="nav-container">
          <v-select
            v-model="utility"
            :items="utilityCompanies"
            label="Concessionárias"
            item-value="id"
            item-text="name"
            required
            :rules="[(v) => !!v || 'Por favor selecione um concessionária']"
            class="d-inline-block company-select"
            dark
          >
          </v-select>
          <v-radio-group
            v-model="person_type"
            dark
            row
            class="d-inline-block pl-3 pr-2"
          >
            <v-radio label="Pessoa Física" value="pf"></v-radio>
            <v-radio label="Pessoa Jurídica" value="pj"></v-radio>
          </v-radio-group>
          <v-text-field
            v-model.number="average"
            :rules="averageRules"
            label="Média de Consumo"
            dark
            required
            prefix="R$"
            class="d-inline-block"
            type="number"
            style="color: #fff"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container
      style="background: #00a4ff"
      fluid
      v-if="average >= 150 && utility"
    >
      <v-layout align-center justify-space-around row fill-height wrap>
        <v-flex xs12 md4 v-for="item in selected_plan" :key="item.id">
          <v-card
            elevation="0"
            class="pa-1 mt-3 rounded-xl ma-2"
            :color="
              (plan && plan.id === item.id) || (!plan && item.recommended)
                ? '#004a7d'
                : 'white'
            "
            :dark="(plan && plan.id === item.id) || (!plan && item.recommended)"
          >
            <v-card-title primary-title class="justify-xs-center">
              <v-flex sm12 class="pt-0 mt-0 ma-0">
                <div class="text-xs-center pt-0 mt-0 pb-0 mb-0">
                  <font color="#00a4ff" class="font-weight-bold"
                    >Você pode
                  </font>
                  <span
                    style="background-color: yellow"
                    class="pa-2 black--text font-weight-bold"
                    >economizar</span
                  >
                </div>
                <div class="text-xs-center pt-0 mt-0 pb-0 mb-0">
                  <span class="economyAte pt-0">Até</span>
                  <span class="economyCurrency pt-0">R$</span>
                  <span class="economyValue text-center font-weight-bold">{{
                    calcEconomy(item.discount * 1) | formatCurrencyInteger
                  }}</span>
                  <span class="economyDecimal"
                    >,{{
                      calcEconomy(item.discount) | formatCurrencyDecimal
                    }}</span
                  >
                </div>
                <p class="pt-0 mt-0 text-xs-center font-weight-bold">
                  por ano e R${{
                    (calcEconomy(item.discount) / 12) | formatCurrency
                  }}
                  por mês
                </p>
                <h5 class="text-xs-center">
                  <span
                    style="
                      color: #fff;
                      background: #00a4ff;
                      padding: 5px;
                      border-radius: 5px;
                    "
                    >No Plano {{ item.name.replace("(Recomendado)", "") }}</span
                  >
                </h5>
              </v-flex>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout
        align-center
        justify-space-around
        row
        fill-height
        wrap
        v-if="plans.length > 0"
      >
        <v-flex xs12 md12 class="text-xs-center">
          <v-card round class="text-xs-center pa-6">
            <v-container wrap>
              <v-layout row wrap>
                <v-flex xs12 md3 class="text-xs-center pa-3">
                  <v-text-field
                    v-model.number="name"
                    :rules="nameRules"
                    label="Nome"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 class="text-xs-center pa-3">
                  <v-text-field
                    label="E-mail"
                    v-model="email"
                    hint="E-mail que quer receber a simulação"
                    :rules="[
                      (v) => !!v || 'Por favor, informe o email',
                      (v) =>
                        /^(([^<>()\[\]\\.,;:\s@&quot;]+(\.[^<>()\[\]\\.,;:\s@&quot;]+)*)|(&quot;.+&quot;))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
                          v,
                        ) || 'E-mail precisa ser válido',
                    ]"
                    name="email"
                    type="email"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 class="text-xs-center pa-3">
                  <v-text-field
                    type="tel"
                    v-model="phone"
                    :rules="[
                      (v) => !!v || 'Por favor, informe o celular',
                      (v) =>
                        v.length > 10 ||
                        'Ops. Parece que esse não é um número de telefone',
                    ]"
                    prepend-icon="phone"
                    @click:prepend="call(phone)"
                    return-masked-value
                    mask="(##)#####-####"
                    label="WhatsApp"
                    hint="Preferencialmente um telefone com whatsapp"
                    persistent-hint
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 class="text-xs-center pa-3">
                  <v-btn
                    round
                    large
                    color="yellow"
                    v-if="plans.length > 0"
                    :disabled="!valid"
                    :loading="loading"
                    @click.prevent="save"
                    ><font color="#000" style="font-weight-bold"
                      >Enviar Simulação</font
                    ></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar
      :color="color"
      :bottom="bottom"
      :top="top"
      :left="left"
      :right="right"
      multi-line
      v-model="snackbar"
      dark
    >
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div v-html="snackMessage"></div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
  </v-form>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { formatPhone } from "../../utils/utils";
import { addLead } from "../../services/leads";

export default {
  data: () => ({
    valid: false,
    average: 0,
    averageRules: [
      (v) => !!v || "Média de Consumo é Obrigatória",
      (v) => v >= 150 || "Contas apenas acima de R$ 150,00",
    ],
    name: "",
    nameRules: [
      (v) => !!v || "Nome é Obrigatória",
      (v) => v.length >= 10 || "Informe o Nome Completo",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    phone: "",
    phoneRules: [
      (v) => !!v || "Média de Consumo é Obrigatória",
      (v) => v >= 150 || "Contas apenas acima de R$ 150,00",
    ],
    person_type: "pf",
    colors: ["purple", "info", "success", "warning", "error"],
    color: null,
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackMessage: "",
    snackbar: false,
    utility: null,
    selected_plan: null,
  }),

  computed: {
    ...mapState("simulator", ["plan", "plans", "loading"]),
    ...mapState("configuration", ["utilityCompanies"]),
    ...mapGetters("simulator", ["plansOrder"]),
    ...mapState(["user"]),
  },

  mounted() {
    if (this.utilityCompanies?.length <= 0) this.getUtilityCompanies();
    if ((!this.plans || this.plans.length <= 0) && this.person_type) {
      this.getPlans(this.person_type);
    }
  },

  watch: {
    average() {
      if (
        (!this.plans || this.plans.length <= 0) &&
        this.person_type &&
        this.average > 0
      )
        this.getPlans(this.person_type);
    },
    person_type() {
      if (this.average > 0) this.getPlans(this.person_type);
    },
    utility: function () {
      this.selected_plan = this.plans.filter(
        (item) =>
          item.utility_company.toLowerCase() == this.utility.toLowerCase(),
      );
    },
  },

  methods: {
    ...mapActions("simulator", ["getPlans"]),
    ...mapActions("configuration", ["getUtilityCompanies"]),
    getPlandByPersonType(person_type) {
      if (this.average > 0) {
        return this.getPlans(person_type);
      }
    },
    calcEconomy(discount) {
      return (this.average * (1 - 0.09) - 50) * (discount / 100 || 0.15) * 12;
    },
    async save() {
      try {
        if (!this.name || this.name.trim() === "") {
          this.snack("Por favor, preencha o nome do membro!", "red", "bottom");
          return;
        }
        if (!this.email || this.email.trim() === "") {
          this.snack("Por favor, preencha o email do membro!", "red", "bottom");
          return;
        }
        if (!this.person_type || this.person_type.trim() === "") {
          this.snack(
            "Por favor, informe se é um cadsatro de PF ou PJ!",
            "red",
            "bottom",
          );
          return;
        }

        let phone = formatPhone(this.phone, "+55");

        let Lead = {
          name: this.name,
          person_type: this.person_type,
          email: this.email.toLowerCase().trim() || this.email,
          phone: phone,
          group: "customer",
          average_consumption: this.average,
          updated_at: new Date(),
          platform: this.platform || "super_simulator",
          status: "simulator",
          saved_at: new Date(),
          saved_by: "SUPER_SIMULATOR",
          send_simulate: true,
          utility: this.utility,
        };
        if (this.user) {
          Lead.saved_source = this.user.partner_id || "enercred";
          Lead.saved_partner = this.user.email;
          Lead.partner = this.user.email;
          Lead.whatsapp_partner = this.user.whatsapp || null;
        }

        addLead(Lead)
          .then(() => {
            this.snack(
              "Tudo Cento! A simulação será enviada para o email " +
                this.email +
                " dentro de alguns segundos.",
              "green",
              "bottom",
            );
            this.loading = false;
          })
          .catch((err) => {
            this.snack(
              "Houve um erro inesperado. Procure nosso suporte!",
              "red",
              "bottom",
            );
            console.error("Erro ao criar lead: ", err);
          });
      } catch (error) {
        console.error(error);
        this.snack(
          "Houve um erro inesperado. Procure nosso suporte!",
          "red",
          "bottom",
        );
        this.loading = false;
      }
    },
    snack(message, color, ...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
  },
};
</script>
<style scoped>
#card {
  border: 1px solid #000;
}
#card_selected {
  border: 1px solid #000080;
  color: "#fff";
}
.economyValue {
  font-family: "Poppins" !important;
  font-size: 110px;
  font-weight: bolder;
  color: #00a4ff;
  text-align: "center";
}
.economyDecimal {
  font-family: "Poppins" !important;
  font-size: 30px;
  font-weight: 600;
  color: #00a4ff;
  vertical-align: 75%;
}
.economyCurrency {
  font-family: "Poppins" !important;
  font-size: 30px;
  font-weight: 600;
  color: #00a4ff;
  vertical-align: 75%;
}
.economyAte {
  font-family: "Poppins" !important;
  font-size: 20px;
  font-weight: 600;
  color: #00a4ff;
  margin-top: 35px;
  position: absolute;
}
.img_topo {
  top: -60px;
  left: 30%;
}
.plan_info {
  background: #00a4ff;
  word-break: break-word;
}
.my-slider > .v-slide-group__next.theme--light.v-icon {
  color: rgb(234, 10, 10) !important;
}
.d-inline-block {
  display: inline-block;
  width: auto;
}
.nav-container {
  row-gap: 30px;
  max-width: fit-content;
}
.company-select {
  max-width: 170px !important;
}
</style>
